import { RouterView } from "vue-router";
import { sealSetupRouting } from "./sealSetUp/sealSetUp.routing"
import { useSealManageRouting } from "./useSealManage/useSealManage.routing"
import { borrowSealRouting } from "./borrowSeal/borrowSeal.routing"
export const SealManageRouting = {
  path: "/sealManage",
  name: "sealManage",
  component: RouterView,
  meta: { title: "印章管理", icon: "seal" },
  children: [
		...sealSetupRouting,
		...useSealManageRouting,
		...borrowSealRouting
	],
};